import { getRequest } from '../utils'

export const getDesignPositionBundle: RequestTypeVariable = {
  getKey: id => ['getDesignPositionBundle', id],
  request: async (id: string, signal: AbortSignal): Promise<DesignPositionBundle> => {
    const { data } = await getRequest<DesignPositionBundle>({
      url: `/projects/${id}/design-position-bundle`,
      signal,
    })

    return data as DesignPositionBundle
  },
}

export const getElementChecksBundle: RequestTypeVariable = {
  getKey: id => ['getElementChecksBundle', id],
  request: async (id: string, signal: AbortSignal): Promise<ElementCheckBundle> => {
    const { data } = await getRequest<ElementCheckBundle>({
      url: `/projects/${id}/element-check-bundle`,
      signal,
    })

    return data as ElementCheckBundle
  },
}
